import React from "react";
import styled from "styled-components";
import { GlassmorphismContainer } from "../styled/shared/Glassmorphism";

const Container = styled.button`
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(-100%, -50%);
  padding: 30px 5px;
  border: none;
  box-shadow: none;
  background: rgb(42 42 42 / 60%);
  cursor: pointer;
  color: #00ff99;
  border-radius: 8px 0px 0px 8px;

  @media (max-width: 600px) {
    top: 0%;
    left: 50%;
    transform: translateY(-100%) translateX(-50%);
    border-radius: 8px 8px 0px 0px;
    padding: 5px 30px;

    svg {
      transform: rotate(90deg);
    }
  }
`;

const left = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="currentColor"
    className="bi bi-chevron-compact-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223"
    />
  </svg>
);

const right = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="currentColor"
    className="bi bi-chevron-compact-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671"
    />
  </svg>
);

export default function HideMenuButton({ isHidden, setIsHidden }) {
  return (
    <Container onClick={() => setIsHidden(!isHidden)}>
      {isHidden ? left : right}
    </Container>
  );
}
